import React, { useEffect, useRef, useState, Children, cloneElement } from "react";
import classNames from "classnames";
import { TabsGroupProps } from "./PropsType";

export default function TabsGroup(props: TabsGroupProps) {
  const {
    activeIndex: activeIndexProps = 0,
    children,
    className,
    onChange,
    animated = true,
    centerMode = false,
    prefixCls = "bm-TabsGroup",
    position = "top",
    scrollable = false,
    ...other
  }: any = props;
  const wrapper = useRef(null);
  const [activeIndex, setActiveIndex] = useState(props.activeIndex || 0);
  const handleChange = (activeIndex: number) => {
    setActiveIndex(activeIndex);
    if (props.onChange) {
      (props.onChange as (index: number) => void)(activeIndex);
    }
  };
  const styleClass = classNames(
    prefixCls,
    `${prefixCls}-${position}`,
    className
  );
  const navChildren: any = [],
    containerChildren: any = [],
    otherChild: any = [];
  let num = 0;
  Children.forEach(children, (child: any, index: number) => {
    const type: any = child.type;
    const fnName = type.fnName;
    const props: any = { ...child.props };
    props.key = index;
    if (fnName === "Tabs") {
      props.activeIndex = activeIndex;
      props.onChange = handleChange;
      props.position = position;
      props.centerMode = centerMode;
      props.scrollable = scrollable;
      navChildren.push(cloneElement(child, props));
    } else if (fnName === "TabContainer") {
      props.index = num;
      props.activeIndex = activeIndex;
      containerChildren.push(cloneElement(child, props));
      num++;
    } else {
      otherChild.push(cloneElement(child, props));
    }
  });
  const x = wrapper.current
    ? -(wrapper.current as any).offsetWidth * activeIndex!
    : 0;
  const y = wrapper.current
    ? -(wrapper.current as any).offsetHeight * activeIndex!
    : 0;
  const horizontal = position === "left" || position === "right";
  const wrapperStyles = {
    transform: !horizontal
      ? `translate3d(${x}px, 0, 0)`
      : `translate3d(0, ${y}px, 0)`,
    WebkitTransform: !horizontal
      ? `translate3d(${x}px, 0, 0)`
      : `translate3d(0, ${y}px, 0)`,
    msTransform: !horizontal
      ? `translate3d(${x}px, 0, 0)`
      : `translate3d(0, ${y}px, 0)`,
    WebkitTransition: animated
      ? "-webkit-transform .3s cubic-bezier(0.35, 0, 0.25, 1)"
      : "",
    transition: animated ? "transform .3s cubic-bezier(0.35, 0, 0.25, 1)" : "",
  };

  useEffect(() => {
    setActiveIndex(props.activeIndex || 0);
  }, [props.activeIndex]);

  return (
    <div className={styleClass} {...other}>
      {navChildren}
      <div className="bm-TabsContainerBox" ref={wrapper}>
        <div className="bm-TabsContainerWrapper" style={wrapperStyles}>
          {containerChildren}
        </div>
      </div>
      {otherChild}
    </div>
  );
}
